export default __webpack_public_path__ + "static/blog-guest-2763b87ddf7b226ce518a8ecb3d678a7.webp";